import PFElement from "@patternfly/pfelement"

class TroubleShootingCard extends PFElement {
  static get tag() {
    return "troubleshooting-card"
  }

  static get events() {
    return { ClickEvent: `${this.tag}:click` }
  }

  set data(data) {
    this.cardTitle.textContent = data?.title
    this.cardContent.textContent = data?.content
    this.cardCta.textContent = data?.buttonContent?.text
    this.cardCta.href = data?.buttonContent?.link
  }

  get html() {
    return `
    <style>
      :host{ display:block }
      .result-card{
        border-radius: 3px;
        border: 1px solid #D2D2D2;
        border-top: none;
        margin-bottom: 32px;
        margin-right: 0;
      }

      .card-body{
        padding: 0 24px 22px 24px;
      }

      .top-border{
        position: relative;
        background-color: #EE0000;
        height: 4px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        margin-left: -1px;
        margin: 0 -1px;
      }

      .heading-container {
        border-bottom: 1px solid #E2E2E2;
        display: flex;
        align-items: center;
      }

      .title{
        font-family: 'Red Hat Text';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #151515;
        margin-top: 24px;
        margin-bottom: 16px;
      }

      .content{
        font-size: 18px;
        margin: 0;
        padding: 24px 0 14px;
      }

      svg{
        margin: 16px 12px 12px 0;
        
      }

      a{
        font-size: 18px;
        font-weight: 700;
        line-height: 27px;
        color: #FFFFFF;
        font-family: RedHatText;
        width: fit-content;
        width: -moz-fit-content;
      }

      .body-container {
        display: flex;
        flex-direction: column;
      }
      
      
      @media (max-width: 768px) {

      }

      @media (max-width: 480px) {
        .result-card{
          margin: 0 16px 16px 16px;
        }

        .card-body{
          padding: 0 16px 16px 16px;
        }

        .title{
          font-size: 18px;
          margin-top: 20px
        }
        .content{
          font-size: 16px;
          padding: 16px 0;
        }
        a{
          font-size: 14px;
        }
      }
    </style>
      <div class="result-card">
        <div class="top-border"></div>
        <div class="card-body">
          <div class="heading-container">
            <svg data-testid="card-icon" aria-hidden="true" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M29.999 6.21176C30.0091 6.0152 29.9422 5.82243 29.8126 5.67437L27.6191 3.48094C27.5567 3.41592 27.4818 3.36419 27.3989 3.32885C27.3159 3.29352 27.2267 3.2753 27.1366 3.2753C27.0464 3.2753 26.9572 3.29352 26.8743 3.32885C26.7914 3.36419 26.7165 3.41592 26.654 3.48094L20.5563 9.57866L15.2263 4.23767L19.3719 1.55073L21.2363 3.41514L18.977 5.67437C18.8491 5.80235 18.7772 5.97593 18.7772 6.15692C18.7772 6.33791 18.8491 6.51149 18.977 6.63947C19.105 6.76745 19.2786 6.83935 19.4596 6.83935C19.6406 6.83935 19.8142 6.76745 19.9422 6.63947L22.6839 3.89769C22.749 3.83526 22.8007 3.76033 22.836 3.67741C22.8714 3.59449 22.8896 3.50528 22.8896 3.41514C22.8896 3.325 22.8714 3.23579 22.836 3.15287C22.8007 3.06994 22.749 2.99502 22.6839 2.93259L19.9422 0.190805C19.8359 0.093206 19.7029 0.029576 19.5603 0.00808083C19.4176 -0.0134143 19.2718 0.00820575 19.1416 0.0701669C19.0867 0.0701669 13.8225 3.53578 13.7677 3.54674C13.6219 3.65268 13.5209 3.80917 13.4844 3.98563C13.4479 4.16208 13.4785 4.34581 13.5703 4.50088C13.5703 4.50088 14.327 5.29052 14.3928 5.34535C13.3827 6.32788 12.6808 7.58351 12.3731 8.95864C12.0653 10.3338 12.165 11.7688 12.66 13.0881L0.88129 24.8668C0.317009 25.4311 -8.40843e-09 26.1964 0 26.9945C8.40843e-09 27.7925 0.317009 28.5578 0.88129 29.1221C1.44557 29.6864 2.2109 30.0034 3.00891 30.0034C3.80692 30.0034 4.57225 29.6864 5.13653 29.1221L16.9152 17.3434C17.9712 17.7581 19.1131 17.9061 20.2398 17.7741C21.3666 17.6421 22.4434 17.2342 23.3749 16.5867L29.9003 6.5298C29.9545 6.43163 29.9881 6.32339 29.999 6.21176ZM17.0359 15.9177C16.9074 15.8669 16.7673 15.8533 16.6315 15.8785C16.4957 15.9038 16.3698 15.9667 16.2682 16.0602L4.20433 28.1241C3.89248 28.4147 3.48001 28.5728 3.05383 28.5653C2.62764 28.5578 2.22101 28.3852 1.91961 28.0838C1.6182 27.7824 1.44556 27.3757 1.43804 26.9495C1.43052 26.5234 1.58871 26.1109 1.8793 25.799L13.9431 13.7352C14.041 13.6323 14.106 13.5024 14.1296 13.3623C14.1621 13.2327 14.1621 13.0971 14.1296 12.9675C13.6334 11.8613 13.4893 10.6294 13.7169 9.43855C13.9444 8.24775 14.5326 7.15571 15.4018 6.31046L20.1176 11.0263C20.1801 11.0913 20.255 11.1431 20.3379 11.1784C20.4208 11.2137 20.51 11.232 20.6002 11.232C20.6903 11.232 20.7795 11.2137 20.8624 11.1784C20.9454 11.1431 21.0203 11.0913 21.0827 11.0263L27.1366 4.9286L28.4526 6.24466L22.322 15.6873C21.5185 16.1313 20.6231 16.3832 19.706 16.4231C18.7889 16.4631 17.8749 16.2901 17.0359 15.9177Z" fill="black"/>
            </svg>   
            <p class="title"></p>
          </div>
          <div class="body-container">
            <p class="content"></p>
            <pfe-cta>
              <a class="card-cta"></a>
            </pfe-cta>
          </div>
        </div>
      </div>
    `
  }

  static get observedAttributes() {
    return ["data"];
  }

  constructor() {
    super(TroubleShootingCard)
    this._clickHandler = this._clickHandler.bind(this);

    this.cardTitle = this.shadowRoot.querySelector('.title')
    this.cardContent = this.shadowRoot.querySelector('.content')
    this.cardCta = this.shadowRoot.querySelector('.card-cta')
    this.shadowRoot.addEventListener("click", this._clickHandler);


  }
  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);

    switch(attr) {
      case "data":

        this.data = JSON.parse(newVal);
        break;
    }
  }

  _clickHandler(event) {
    const q = "Troubleshoot your issue"

    this.emitEvent(TroubleShootingCard.events.ClickEvent, {
      detail: {
        q
      }
    });
    
  }

}


PFElement.create(TroubleShootingCard);

export default TroubleShootingCard;